<template>
  <pt-branch-company-table class="pt-branch-company-tablee__withData" ref="table" :tableLabels="tableLabels" :tableData="tableData"
   @getTableData="getTableData" :totalNumber="totalNumber" :isOutside="isOutside">
      <slot/>
  </pt-branch-company-table>
</template>

<script>
import PtBranchCompanyTable from './index'
export default {
  name: 'pt-branch-company-table__withData',
  components: {
    'pt-branch-company-table': PtBranchCompanyTable
  },
  props: {
    tableLabels: {
      type: Array,
      default: function () {
        return []
      }
    },
    pageSize: {
      type: Number,
      default: 10
    },
    paramsData: {
      type: Object,
      default: function () {
        return {}
      }
    },
    isFromRouter: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    page () {
      return this.$refs.table.page
    }
  },
  data () {
    return {
      tableData: [],
      totalNumber: 0,
      isOutside: false
    }
  },
  watch: {
    paramsData: {
      handler: function (val) {
        if (this.isFromRouter) {
          this.isOutside = true
          this.getTableData(this.page)
        } else {
          this.resetPage()
        }
      }
    }
  },
  methods: {
    resetPage () {
      this.$refs.table.resetPage()
    },
    getTableData (page, next) {
      let data = {
        ...this.paramsData,
        pageableParam: {
          page: this.page,
          size: this.pageSize
        }
      }
      this.$store.dispatch('getBranchCompanyList', data).then(res => {
        res.data.forEach(item => {
          item.addresses = item.addresses ? item.addresses.toString() : ''
          let businessName = []
          if (item.business) {
            item.business.forEach(param => {
              businessName.push(param.name)
            })
          }
          item.businessName = businessName ? businessName.toString() : ''
        })
        this.tableData = res.data
        this.totalNumber = res.totalNumber
        if (next) {
          next(res.data)
        }
      }).catch(err => {
        this.$message.error(err || '获取分/子公司列表失败')
      })
    }

  }
}
</script>
